__turbopack_context__.v({
  "basketItem": "basket-item-module-scss-module__k2uHBW__basketItem",
  "relatedProducts": "basket-item-module-scss-module__k2uHBW__relatedProducts",
  "relatedProducts_disabled": "basket-item-module-scss-module__k2uHBW__relatedProducts_disabled",
});
